﻿import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
// @mui
import { List, Collapse } from '@mui/material';
//
import { NavListProps } from '../type';
import NavItem from './NavItem';
import { getActive, isExternalLink } from '..';
import useAuth from 'src/hooks/useAuth';

// ----------------------------------------------------------------------

type NavListRootProps = {
  data: NavListProps;
  depth: number;
  hasChildren: boolean;
  isCollapse?: boolean;
};

export default function NavList({
  data,
  depth,
  hasChildren,
  isCollapse = false,
}: NavListRootProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const active = getActive(data.path, pathname);

  const [open, setOpen] = useState(active);

  const handleClickItem = () => {
    if (!hasChildren) {
      navigate(data.path);
    }
    setOpen(!open);
  };

  return (
    <>
      <NavItem
        item={data}
        depth={depth}
        open={open}
        active={active}
        isCollapse={isCollapse}
        handleClickItem={handleClickItem}
      />
      {!isCollapse && hasChildren && (
        <Collapse in={open} unmountOnExit>
          <List component="div" disablePadding>
            <NavSubList data={data.children} depth={depth} />
          </List>
        </Collapse>
      )}
    </>
  );
}

// ----------------------------------------------------------------------

type NavListSubProps = {
  data: NavListProps[];
  depth: number;
};

function NavSubList({ data, depth }: NavListSubProps) {
  const { user } = useAuth();

  return (
    <>
      {data.map((list) => {
        if (list.roles && list.roles.length > 0) {
          const hasRole = user?.roles?.some((r: string) => list.roles!.includes(r));
          if (!hasRole) return null;
        }

        let validChildren: boolean = false;

        if (list.children) {
          validChildren = user && list.children.map((x: any) => Object.keys(user.permission).includes(x.title.toLowerCase()));
        }
        else {
          const titleMatch = user
            ? Object.keys(user.permission).map(x => x.toLowerCase()).includes(list.title.toLowerCase())
            : false;

          const pathSegments = list.path.split('/').filter(Boolean);
          const pathMatch = user
            ? pathSegments.some(segment => Object.keys(user.permission).map(x => x.toLowerCase()).includes(segment.toLowerCase()))
            : false;

          validChildren = titleMatch || pathMatch;
        }

        if (validChildren) {
          return (
            <NavList
              key={list.title + list.path}
              data={list}
              depth={depth + 1}
              hasChildren={!!list.children}
            />
          );
        }
        else {
          return <></>;
        }
      })}
    </>
  );
}